//Always use file name as prefix to avoid duplicate constants

export const KEY_FEAURE_EXISTS = '[research model key features menu]'; // BMW research model page- key features menu

export const WAIT_FOR_SPECIALS_API_DATA = '[research model is specials loaded]'; // wait for vehicle specials to load

